require('./adGeneratorService');

"use strict";

angular.module('app.admin.adGenerator.adGeneratorController', [
  'app.admin.adGenerator.adGeneratorService'
])
    .controller('app.admin.adGenerator.adGeneratorController', [
      '$scope',
      'app.admin.adGenerator.adGeneratorService',
      '$sce',
      function ($scope, adGeneratorService, $sce) {
        $scope.sizes = null;
        $scope.leagues = null;
        $scope.teams = null;

        $scope.selectedSize = null;
        $scope.selectedLeague = null;
        $scope.selectedTeam = null;
        $scope.code = null;

        $scope.getCode = function () {
          let id, type;

          let size = $scope.selectedSize;

          if ($scope.selectedTeam) {
            id = $scope.selectedTeam;
            type = 'team';
          }
          else if ($scope.selectedLeague) {
            id = $scope.selectedLeague;
            type = 'league';
          }

          if (id && type && size) {
            adGeneratorService.getAd(type, id, size)
                .then(function (response) {
                  $scope.code = $sce.trustAsHtml(response.data);
                });
          }
        };

        $scope.getTeams = function () {
          adGeneratorService.getTeams($scope.selectedLeague)
              .then(function (response) {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                }
                else {
                  $scope.teams = data;
                }
              })
        };

        adGeneratorService.getSizes()
            .then(function (response) {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              }
              else {
                $scope.sizes = data;
              }
            });

        adGeneratorService.getLeagues()
            .then(function (response) {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              }
              else {
                $scope.leagues = data;
              }
            });
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/adGenerator/adGeneratorController.js